<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-row>
            <v-col cols="12" md="3" class="ml-3">
              <v-btn color="#7BC243" to="/grnfile" class="white--text cataloguebtn">View All Files</v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-card-title>
            <!--		   <v-row>-->
            <!--			-->
            <!--				<v-spacer></v-spacer>-->
            <!--				<v-col cols="12" md="4">-->
            <!--				  <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-checkoffSettlementDetails></v-text-field>-->
            <!--				</v-col>-->
            <!--			</v-row>-->
            <v-row>

              <v-col cols="4" md="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search By Outturn" single-line
                              hide-details></v-text-field>

              </v-col>
              <v-col
                cols="8"
                class="text-right"
              >
                <h4> {{ records[0]?.documentUpload?.fileName }}</h4>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <!--            <v-progress-circular-->
            <!--              v-if="loading"-->
            <!--              indeterminate-->
            <!--              color="primary"-->
            <!--            ></v-progress-circular>-->

            <v-data-table :loading="loading" v-model="selected" :headers="computedHeaders" :items="records"
                          item-key="id"
                          show-select
                          class="elevation-1" :search="search" :single-select="singleSelect">

              <template v-slot:top v-if="hasCanBeApprovedData(records) && $can('CAN_APPROVE_GRN')">

                <v-btn class="mr-2"
                       @click="confirmAction('APPROVE_SELECTED')"
                       color="primary">Approve Selected
                </v-btn>

                <v-btn class="ml-2"
                       @click="confirmAction('REJECT_SELECTED')"
                       color="warning">Reject Selected

                </v-btn>

                <v-btn class="ml-2"
                       @click="confirmAction('APPROVE_ALL')"
                       color="warning">Approve All

                </v-btn>

                <v-btn class="ml-2"
                       @click="confirmAction('REJECT_ALL')"
                       color="warning">Reject All

                </v-btn>

              </template>

              <template v-slot:[`item.data-table-select`]="{ isSelected, select,item }">

                <v-simple-checkbox
                  :ripple="false"
                  color="green"
                  :value="isSelected"
                  @input="select($event)"
                  v-if=" item?.status?.id !==3 || !$can('CAN_APPROVE_GRN')"
                  disabled
                  class="d-none"
                ></v-simple-checkbox>
                <v-simple-checkbox
                  :ripple="false"
                  color="green"
                  :value="isSelected"
                  v-else
                  @input="select($event)"
                ></v-simple-checkbox>

              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on" text icon class="actions">
                      <v-icon class="secondary--text"> more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="$can('CAN_APPROVE_GRN') && hasGrnStatusIdData(item) || $can('CAN_UPLOAD_GRN') && hasGrnApproveMillerData(item)"
                      @click="showEditDialog(item,'edit')">
                      <v-list-item-title> Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="$can('CAN_UPLOAD_GRN') && hasGrnApproveMillerData(item) || $can('CAN_APPROVE_GRN') && hasGrnApproveWarehouseData(item)"
                      @click="showEditDialog(item,'approve')">
                      <v-list-item-title> Approve</v-list-item-title>
                    </v-list-item>

                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title
          class="body-2 primary--text font-weight-bold text-capitalize"
        >Dispatch/Grn Records
        </v-card-title
        >
        <v-card-text class="primary--text">
          {{ confirmMessage }}
          <v-text-field
            name="comment"
            label="Comment"
            v-model="approverComment"
            :rules="commentRules"
            required
          >
          </v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="confirmDialog = false"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="accent--text logoutbtn"
            @click="approveRecords()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline accent--text">{{ action }} GRN Record</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.outTurnNumber" label="OutTurn" v-bind:readonly="approve">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.bags" label="Bags" required v-bind:readonly="approve">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.pockets" label="Pockets" required v-bind:readonly="approve">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.grossWeight" label="Gross W" required v-bind:readonly="approve">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.tareWeight" label="Tare W" required v-bind:readonly="approve">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="grnRecord.netWeight" label="Net W" required v-bind:readonly="approve">
                </v-text-field>
              </v-col>
            </v-row>
<!--            <v-flex xs12 sm6 md6>-->
<!--              <v-checkbox-->
<!--                v-bind:readonly="approve"-->
<!--                v-model="grnRecord.deleteFlag"-->
<!--                label="Delete"-->
<!--                @change="handleChange"-->
<!--              ></v-checkbox>-->
<!--            </v-flex>-->
          </v-form>
        </v-card-text>

        <v-card-actions v-if="approve">
          <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="editDialog = false">Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerApproveRecord">Approve</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="editDialog = false">Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerEditRecord">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
	name: 'grnfiledetails',
	data: function () {
		return {
			headers: [
				{ text: 'OutTurn', value: 'outTurnNumber' },
				{ text: 'Grade', value: 'grade' },
        { text: 'SplitNumber', value: 'splitNumber' },
				{ text: 'Marks', value: 'marks' },
				{ text: 'Bags', value: 'bags' },
				{ text: 'Pockets', value: 'pockets' },
				{ text: 'Season', value: 'season' },
				{ text: 'SaleNo', value: 'saleNumber' },
				{ text: 'Miller', value: 'millerCode' },
				{ text: 'Broker', value: 'brokerCode.organisationCode' },
				{ text: 'GrossW', value: 'grossWeight' },
				{ text: 'TareW', value: 'tareWeight' },
				{ text: 'NetW', value: 'netWeight' },
				// { text: 'Status', value: 'status.statusName' },
				{ text: 'Actions', value: 'actions' }
			],
			selected: [],
			recordsToApprove: [],
			search: '',
			singleSelect: false,
			grnRecord: {},
			editDialog: false,
			approve: false,
			valid: true,
			action: '',
			confirmDialog: false,
			confirmMessage: '',
			commentRules: [(v) => !!v || 'Comment is required'],
			approverComment: '',
			record_count: 0

		}
	},
	watch: {},
	computed: {
		...mapState({
			loading: state => state.grnfile.loading,
			records: state => state.grnfile.records

		}),

		computedHeaders () {
			// Check if the status column should be added
			const showStatus = this.hasGrnStatus().length > 0
			const headers = [...this.headers]

			if (showStatus) {
				// Insert the status header at the desired position
				headers.splice(12, 0, { text: 'Status', value: 'status.statusName' })
			}

			return headers
		}
		// countSelectedItems () {
		// 	// eslint-disable-next-line no-undef
		// 	return this.records.filter(item => item.status.statusName !== 'HOLDING_STATUS').length || item.status.statusName !== 'PAID' || item.status.statusName !== 'COLLECTED'
		// }
	},
	methods: {
		handleChange () {
			// Update deleteFlag to true if the checkbox is checked
			this.grnRecord.deleteFlag = true
		},

		confirmAction (action) {
			this.action = action
			this.confirmDialog = true
			this.recordsToApprove = this.action.includes('SELECTED') ? this.selected.filter(record => record.status && (record.status.id === 3 && record?.requireReapproval === 'N'))
				: this.records.filter(record => record.status && (record.status.id === 3 && record?.requireReapproval === 'N'))
			this.confirmMessage = action + ' - ' + this.recordsToApprove.length + ' records'
		},
		hasGrnStatusIdData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'HOLDING_STATUS' || item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL' ||
			item.status.statusName === 'PENDING_APPROVAL'
			)
			// return this.records.filter(item => item.status !== null);
		},

		hasGrnApproveWarehouseData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL')
		},

		hasGrnApproveMillerData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'REFERRED_TO_MILLER')
			// return this.records.filter(item => item.status !== null);
		},

		hasCanBeApprovedData (records) {
			return records.length > 0 && records.some(record => record.status && (record.status.statusName === 'PENDING_APPROVAL'))
		},

		hasGrnStatus () {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return this.records.filter(item => item.status !== null)
		},
		...mapActions({
			warehouseApproveRecords2: 'grnfile/warehouseApproveRecords2',
			warehouseApproveRecords: 'grnfile/warehouseApproveRecords',
			editRecord: 'grnfile/editRecord',
			millerApproveRecord: 'grnfile/millerApproveRecord'
		}),
		showEditDialog (item, type) {
			this.grnRecord = item
			this.editDialog = true
			this.action = type
			if (type !== 'edit') {
				this.approve = true
			}
		},
		approveRecords () {
			if (this.recordsToApprove.length === 0) {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: 'No record selected for action ' + this.action
				})
			} else {
				const recordData = {
					action: this.action,
					comment: this.approverComment,
					records: this.recordsToApprove
				}
				this.warehouseApproveRecords2(recordData).then(response => {
					if (response.data.error === false) {
						this.$store.dispatch('alert/displayAlert', {
							snackbar: true,
							color: 'primary',
							message: response.data.message
						})
					} else {
						this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
					}
					this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
					this.selected = []
					this.confirmDialog = false
					this.recordsToApprove = []
					this.approverComment = ''
					this.confirmMessage = ''
				}).catch(error => {
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response.data ? error.response.data.message : 'Error ocurred'
					})
				})
			}
		},
		triggerEditRecord () {
			this.editRecord(this.grnRecord).then(response => {
				if (response.data.error === false) {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				} else {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
				}
				this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
				this.selected = []
				this.editDialog = false
			}).catch(error => {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: error.response.data ? error.response.data.message : 'Error ocurred'
				})
				this.editDialog = false
			})
		},
		triggerApproveRecord () {
			// this.millerApproveRecord(this.grnRecord).then(response => {
			this.editRecord(this.grnRecord).then(response => {
				if (response.data.error === false) {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				} else {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
				}
				this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
				this.selected = []
				this.editDialog = false
			}).catch(error => {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: error.response.data ? error.response.data.message : 'Error ocurred'
				})
				this.editDialog = false
			})
		}
	},
	created () {
		this.$store.dispatch('grnfile/resetGrnFiles')
		this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
		// console.log(this.$store.dispatch('grnfile/viewFile', this.$route.params.id))
	}

}
</script>
<style>
</style>
